import { Nullable } from 'utils/types';

export type VulnerabilityCategory = string;
export type VulnerabilityId = number;
export type InformationProvidedBy =
  | InformationSource.Applicant
  | InformationSource.Broker
  | InformationSource.FMA
  | InformationSource.POA
  | InformationSource.Other
  | InformationSource.OtherApplicant;

export enum VulnerabilityField {
  Id = 'id',
  Category = 'category',
  DateOfConsent = 'dateOfConsent',
  DateRecorded = 'dateRecorded',
  CommentsAndAdditionalInformation = 'commentsAndAdditionalInformation',
  InformationProvidedBy = 'informationProvidedBy',
  IsAppropriateForExplicitConsent = 'isAppropriateForExplicitConsent',
  IsExplicitConsentFromCustomer = 'isExplicitConsentFromCustomer',
}

export interface Vulnerability {
  [VulnerabilityField.Id]: VulnerabilityId;
  [VulnerabilityField.Category]: VulnerabilityCategory;
  [VulnerabilityField.DateOfConsent]: Nullable<string>;
  [VulnerabilityField.InformationProvidedBy]: InformationProvidedBy;
  [VulnerabilityField.IsAppropriateForExplicitConsent]: Nullable<boolean>;
  [VulnerabilityField.IsExplicitConsentFromCustomer]: Nullable<boolean>;
  [VulnerabilityField.CommentsAndAdditionalInformation]: Nullable<string>;
  [VulnerabilityField.DateRecorded]: string;
}

export enum InformationSource {
  Broker = 'BROKER',
  FMA = 'FMA',
  Applicant = 'APPLICANT',
  POA = 'POA',
  Other = 'OTHER',
  OtherApplicant = 'OTHER_APPLICANT',
}

export const isInformationProvidedByCustomer = (value: InformationProvidedBy): boolean => {
  return [InformationSource.Applicant].includes(value);
};
